module.exports = __webpack_public_path__ + "img/3.30daeec0.png";